<div v-bind:class="getClassName">
  <div class="matrix_selectOptionName">{{name}} <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip></div>
  <Select2
    v-model="value"
    :options="options"
    :settings="settings"
    :id="getId"
    :class="getIsSelectDisabled ? 'custom-select2-disabled' : ''"
  />
  <div v-if="selectId == 'options_select_content_format' || selectId == 'options_select_cover_format'">
    <appInputCustomFormatInsert :ppCode="getPPCode"></appInputCustomFormatInsert>
  </div>
  <input v-if="showColorPickerForOption" id="margin_color_input" v-on:change="proccessMarginColor" type="color" :value="getMarginColor" style="width:100%; cursor: pointer;">
</div>
